import React from 'react';
import {
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
  Bars3BottomLeftIcon,
  ListBulletIcon,
  NumberedListIcon,
} from '@heroicons/react/24/outline';

/**
 * Formatting toolbar shown above the draft editor in the create-article wizard.
 * Extracted verbatim from pages/Articles/CreateArticle.js.
 */
export default function CreateEditorToolbar({ runEditorCommand, convertCurrentBlock, insertEditorBlock }) {
  return (
    <div className="editor-top-toolbar">
      <div className="editor-top-toolbar__group">
        <button type="button" title="Cofnij" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('undo')} className="editor-top-toolbar__icon-btn">
          <ArrowUturnLeftIcon className="h-4 w-4" />
        </button>
        <button type="button" title="Ponów" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('redo')} className="editor-top-toolbar__icon-btn">
          <ArrowUturnRightIcon className="h-4 w-4" />
        </button>
      </div>
      <span className="editor-top-toolbar__separator" />

      <div className="editor-top-toolbar__group">
        <select
          className="editor-top-toolbar__select"
          defaultValue="paragraph"
          onChange={(e) => convertCurrentBlock(e.target.value)}
          title="Styl tekstu"
        >
          <option value="paragraph">Text</option>
          <option value="heading2">H2</option>
          <option value="heading3">H3</option>
          <option value="unordered">List</option>
          <option value="ordered">Numbered</option>
        </select>
      </div>
      <span className="editor-top-toolbar__separator" />

      <div className="editor-top-toolbar__group">
        <button type="button" title="Pogrubienie" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('bold')} className="editor-top-toolbar__icon-btn">
          B
        </button>
        <button type="button" title="Kursywa" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('italic')} className="editor-top-toolbar__icon-btn">
          I
        </button>
        <button type="button" title="Podkreślenie" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('underline')} className="editor-top-toolbar__icon-btn">
          U
        </button>
        <button type="button" title="Przekreślenie" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('strikeThrough')} className="editor-top-toolbar__icon-btn">
          S
        </button>
      </div>
      <span className="editor-top-toolbar__separator" />

      <div className="editor-top-toolbar__group">
        <button type="button" title="Wyrównaj do lewej" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('justifyLeft')} className="editor-top-toolbar__icon-btn">
          <Bars3BottomLeftIcon className="h-4 w-4" />
        </button>
        <button type="button" title="Lista punktowana" onMouseDown={(e) => e.preventDefault()} onClick={() => convertCurrentBlock('unordered')} className="editor-top-toolbar__icon-btn">
          <ListBulletIcon className="h-4 w-4" />
        </button>
        <button type="button" title="Lista numerowana" onMouseDown={(e) => e.preventDefault()} onClick={() => convertCurrentBlock('ordered')} className="editor-top-toolbar__icon-btn">
          <NumberedListIcon className="h-4 w-4" />
        </button>
      </div>
      <span className="editor-top-toolbar__separator" />

      <div className="editor-top-toolbar__group">
        <button type="button" title="Nowy paragraf" onMouseDown={(e) => e.preventDefault()} onClick={() => insertEditorBlock('paragraph', { text: '' })} className="editor-top-toolbar__icon-btn editor-top-toolbar__icon-btn--text">P</button>
        <button type="button" title="Nowy nagłówek H2" onMouseDown={(e) => e.preventDefault()} onClick={() => insertEditorBlock('header', { text: '', level: 2 })} className="editor-top-toolbar__icon-btn editor-top-toolbar__icon-btn--text">H2</button>
        <button type="button" title="Nowy nagłówek H3" onMouseDown={(e) => e.preventDefault()} onClick={() => insertEditorBlock('header', { text: '', level: 3 })} className="editor-top-toolbar__icon-btn editor-top-toolbar__icon-btn--text">H3</button>
      </div>
    </div>
  );
}
